import { __spreadArray } from 'tslib';
import React from 'react';
import '../../../../Chip/StaticChip/StaticChip.js';
import { Chip } from '../../../../Chip/Chip/Chip.js';
import { ChipList } from '../../../../Chip/ChipList/ChipList.js';

var MultiSelectChipList = function MultiSelectChipList(props) {
  var selectedItems = props.selectedItems,
    sourceRef = props.sourceRef,
    ariaChipActionLabel = props.ariaChipActionLabel,
    _onClick = props.onClick;
  var chipRefs = selectedItems.filter(function (item) {
    return !item.disabled;
  }).reduce(function (arr, _chip, index) {
    var mutatedArr = __spreadArray([], arr, true);
    mutatedArr[index] = /*#__PURE__*/React.createRef();
    return mutatedArr;
  }, []);
  return selectedItems && selectedItems.length > 0 ? ( /*#__PURE__*/React.createElement(ChipList, null, selectedItems.filter(function (item) {
    return item.disabled;
  }).map(function (disabledItem) {
    return /*#__PURE__*/React.createElement(Chip, {
      "aria-disabled": true,
      key: disabledItem.uniqueItemId,
      actionLabel: ariaChipActionLabel,
      removable: true
    }, disabledItem.chipText ? disabledItem.chipText : disabledItem.labelText);
  }), selectedItems.filter(function (item) {
    return !item.disabled;
  }).map(function (enabledItem, index) {
    return /*#__PURE__*/React.createElement(Chip, {
      key: enabledItem.uniqueItemId,
      removable: !enabledItem.disabled,
      onClick: function onClick() {
        var _a, _b, _c, _d, _e;
        if (selectedItems.filter(function (item) {
          return !item.disabled;
        }).length > 1) {
          if (index > 0) {
            (_b = (_a = chipRefs[index - 1]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
          } else if (index === 0) {
            (_d = (_c = chipRefs[1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.focus();
          }
        } else {
          (_e = sourceRef === null || sourceRef === void 0 ? void 0 : sourceRef.current) === null || _e === void 0 ? void 0 : _e.focus();
        }
        if (!!_onClick) {
          _onClick(enabledItem);
        }
      },
      actionLabel: ariaChipActionLabel,
      ref: chipRefs[index]
    }, enabledItem.chipText ? enabledItem.chipText : enabledItem.labelText);
  }))) : null;
};

export { MultiSelectChipList };
//# sourceMappingURL=MultiSelectChipList.js.map
